// Allocation slices as the donut shows them (FT-70).

import type { AllocationSlice } from "@finance-os/shared-types/api";

export const OTHER_SLICE_KEY = "other";

/**
 * The slices a donut can draw: only positive values (a margin-loan cash balance
 * has no share of the pie), at most `max` of them, the smallest folded into one
 * "Other" slice so the series palette never has to repeat. Expects `slices`
 * sorted by value, largest first (the API's order).
 */
export function collapseSlices(slices: AllocationSlice[], max: number): AllocationSlice[] {
  const drawable = slices.filter((s) => s.value_eur_minor > 0);
  if (drawable.length <= max) return drawable;
  const head = drawable.slice(0, max - 1);
  const tail = drawable.slice(max - 1);
  return [
    ...head,
    {
      key: OTHER_SLICE_KEY,
      label: "Other",
      value_eur_minor: tail.reduce((s, x) => s + x.value_eur_minor, 0),
      weight_pct: tail.reduce((s, x) => s + x.weight_pct, 0),
    },
  ];
}
